import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { ref: "root" }
const _hoisted_2 = {
  id: "searchLabel",
  class: "sr-only"
}
const _hoisted_3 = {
  key: 0,
  for: "search",
  class: "whitespace-no-wrap pointer-events-none absolute left-0 top-0 w-full pr-20 text-2xl font-normal lg:text-4xl"
}
const _hoisted_4 = {
  key: 0,
  class: "hidden opacity-20 lg:inline"
}
const _hoisted_5 = { class: "sr-only" }
const _hoisted_6 = { class: "sr-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_auto_complete = _resolveComponent("auto-complete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.t('search')), 1),
    _createVNode(_component_auto_complete, {
      suggestions: _ctx.suggestions,
      modelValue: _ctx.fullText,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fullText) = $event)),
      "input-id": "search",
      "pt:pcInputText:root:name": "fullText",
      "pt:pcInputText:root:type": "search",
      "input-class": "search-input w-full min-w-0 flex-auto rounded-none bg-white text-2xl font-normal lg:text-4xl",
      "aria-labelledby": "searchLabel",
      onKeydown: _ctx.handleKeydown,
      showEmptyMessage: false,
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.focus = true)),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.focus = false)),
      onComplete: _ctx.handleInput,
      onSelected: _ctx.handleSelected
    }, null, 8, ["suggestions", "modelValue", "onKeydown", "onComplete", "onSelected"]),
    (!_ctx.fullText.length)
      ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.t('search')) + " ", 1),
          (_ctx.grandTotal)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.t('search_placeholder', { number: _ctx.grandTotal })), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.fullText)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
          type: "reset",
          class: "px-6"
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('reset')), 1),
          _cache[5] || (_cache[5] = _createElementVNode("svg", {
            class: "search-close-icon",
            focusable: "false",
            "aria-hidden": "true",
            width: "20",
            height: "20"
          }, [
            _createElementVNode("use", { "xlink:href": "#close" })
          ], -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "submit",
      class: "-mr-3 px-3",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.triggerSearch && _ctx.triggerSearch(...args)))
    }, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('search')), 1),
      _cache[6] || (_cache[6] = _createElementVNode("svg", {
        class: "search-icon",
        focusable: "false",
        "aria-hidden": "true",
        width: "20",
        height: "20"
      }, [
        _createElementVNode("use", { "xlink:href": "#magnifier" })
      ], -1))
    ])
  ], 512))
}